import { createI18n } from 'vue-i18n';
import es from '../locales/es.json';
import en from '../locales/en.json';

const i18n = createI18n({
  legacy: false, // Importante para usar Composition API (setup)
  locale: localStorage.getItem('user_lang') || 'en', // Detecta preferencia guardada o usa Inglés
  fallbackLocale: 'es', // Si falta una traducción en inglés, usa español
  messages: {
    es,
    en
  }
});

export default i18n;